import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Helper component for form field labels with tooltips
const FieldLabel = ({ label, tooltip }: { label: string; tooltip: string }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {label}
    <Tooltip title={tooltip} arrow placement="top">
      <IconButton size="small" sx={{ ml: 0.5, p: 0 }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </div>
);

export default FieldLabel;
